import {TheCryptSymbol, ISymbolData, TheCryptSymbolStates} from "./TheCryptSymbol";
import {TweenMax, TimelineLite, TimelineMax} from "gsap";
import {TheCrypt} from "../TheCrypt";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TheCryptSoundManager} from "../sound/TheCryptSoundManager";
import {TheCryptSoundConfig} from "../configs/TheCryptSoundConfig";

export class TheCryptFullWild extends TheCryptSymbol {

    protected getSymHeight(): number {
        return 600;
    }

    constructor(symbolData: ISymbolData, state: TheCryptSymbolStates = TheCryptSymbolStates.NORMAL) {
        super(symbolData);
        this.addChild(this._wildMultiplier);
    }

    public getStateAnimation(state: TheCryptSymbolStates = TheCryptSymbolStates.NORMAL, duration: number = 0): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this.addSpine();
        this._spine?.position.set(0, 300);
        if (state === TheCryptSymbolStates.BLUR) {
            tl.add(() => {
                this._spine?.state.setAnimation(1, "spin", false);
            });
        } else if (state === TheCryptSymbolStates.EXPAND) {
            tl.add([
                new SpineTween(this._spine!, 0, `expand${TheCrypt.model.hasNoAvalancheWin ? "_no_win" : ""}`)
            ]);
            tl.add(() => {
                this._spine!.state.setAnimation(0, "idel_loop", true);
            });
        }

        return tl;
    }

    public playInitialWin(winType: string): TimelineMax {
        winType = (winType.length > 0 ? "_" : "") + winType;
        this.parent.removeChild(this);
        TheCrypt.realArea.allReels[this.reelId].reelView.scatterWinView.addChild(this);
        this.isRemoved = true;
        return new TimelineLite().add([
            new SpineTween(this._spine!, 1, `win_toggle${winType}`)
        ]);
    }

    public showMultiplier(multiplier: number = 1): void {
        this._wildMultiplier.scale.set(1);
        this._wildMultiplier.text = "X" + multiplier.toString();
        this._wildMultiplier.position.set(0, 175);
        this._wildMultiplier.visible = true;
    }

    public explode(winType: string): TimelineLite {
        winType = (winType.length > 0 ? "_" : "") + winType;
        return new TimelineMax().add([
                TweenMax.to(this._wildMultiplier, 0.3, {alpha: 0}),
                new SpineTween(this._spine!, 1, `win_break${winType}`)
            ]).add(() => {
                this.remove();
            });
    }
}